import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';

export default function SystemLogs() {
  const [stats, setStats] = useState([]);
  const [ctxs, setCtxs] = useState([]);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get('/logs/stats').then(r => setStats(unwrap(r) || []));
    api.get('/logs/contexts').then(r => setCtxs(unwrap(r) || []));
    api.get('/logs').then(r => setLogs(unwrap(r) || []));
  }, []);

  return (
    <>
      <h1>System Logs</h1>
      <div className="card">
        <strong>By level:</strong> {stats.map(s => `${s._id}: ${s.count}`).join(' · ') || '—'}
      </div>
      <div className="card">
        <strong>Contexts:</strong> {ctxs.join(', ') || '—'}
      </div>
      <div className="card">
        <table className="table">
          <thead><tr><th>When</th><th>Level</th><th>Context</th><th>Message</th></tr></thead>
          <tbody>
            {logs.map(l => (
              <tr key={l._id}>
                <td>{new Date(l.createdAt).toLocaleString()}</td>
                <td>{l.level}</td>
                <td>{l.context}</td>
                <td>{l.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
